import React from 'react'

import { useSelector } from 'react-redux'
import { Button, Collapse, } from "reactstrap"
import FormsList from './FormsList'


const Collapsible = ({ isCollapseOpen, toggleModal, setDeleteing }) => {
    const forms = useSelector((state) => state.forms)

    return (
        <Collapse className="my-3 flex flex-col gap-4" isOpen={isCollapseOpen}>
            <div className="flex items-center gap-10">
                <Button color="primary" onClick={toggleModal} className="flex-none">+ Ajouter formulaire</Button>
                {/* {forms.length > 1 && <Button color="secondary" onClick={toggleJoinModal} className="flex-none">+ Add Join</Button>} */}
            </div>
            <FormsList setDeleteing={setDeleteing} />
        </Collapse>
    )


}

export default Collapsible
